export default {
  expenseLineItem: undefined,
  expenseLineItems: [],
  pettyCashAdvanceDocumentLines: [],
  pettyCashADocumentLines: [],
};
